import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TClientTags, IClient } from "@ts/common-types";
import * as Sentry from "@sentry/react";

const clientListSlice = createSlice({
    name: "clients",
    initialState: { value: [] },
    reducers: {
        updateClientList: (state, action: PayloadAction<IClient[]>) => {
            state.value = action.payload;
        },
    },
});

const activeClientIdSlice = createSlice({
    name: "activeClientId",
    initialState: { value: 0 },
    reducers: {
        updateActiveClientId: (state, action: PayloadAction<number>) => {
            sessionStorage.setItem("active_client", action.payload);
            state.value = action.payload;
            if (action.payload !== null && action.payload !== undefined) {
                Sentry.setTag("client_id", action.payload.toString());
            } else {
                Sentry.setTag("client_id", null);
            }
        },
    },
});

const clientIdOnChannelChangeSlice = createSlice({
    name: "clientIdOnChannelChange",
    initialState: { value: 0 },
    reducers: {
        updateClientIdOnChannelChange: (
            state,
            action: PayloadAction<number>
        ) => {
            sessionStorage.setItem("active_client", action.payload);
            state.value = action.payload;
            if (action.payload !== null && action.payload !== undefined) {
                Sentry.setTag("client_id", action.payload.toString());
            } else {
                Sentry.setTag("client_id", null);
            }
        },
    },
});

const activeClientGroupIdSlice = createSlice({
    name: "activeClientGroupId",
    initialState: { value: null },
    reducers: {
        updateActiveClientGroupId: (state, action: PayloadAction<number>) => {
            state.value = action.payload;
            if (action.payload !== null && action.payload !== undefined) {
                Sentry.setTag("client_group_id", action.payload.toString());
            } else {
                Sentry.setTag("client_group_id", null);
            }
        },
    },
});

const clientSubGroupIdSlice = createSlice({
    name: "clientSubGroupId",
    initialState: { value: null },
    reducers: {
        updateClientSubGroupId: (state, action: PayloadAction<number>) => {
            state.value = action.payload;
            if (action.payload !== null && action.payload !== undefined) {
                Sentry.setTag("client_subgroup_id", action.payload.toString());
            } else {
                Sentry.setTag("client_subgroup_id", null);
            }
        },
    },
});

const tagTypeListLoadingSlice = createSlice({
    name: "tagTypeListLoading",
    initialState: { value: false },
    reducers: {
        updateTagTypeListLoading: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const clientTagsListSlice = createSlice({
    name: "clientTagsList",
    initialState: { value: [] },
    reducers: {
        updateClientTagsList: (state, action: PayloadAction<TClientTags[]>) => {
            state.value = action.payload;
        },
    },
});

const tagTypeListSlice = createSlice({
    name: "tagTypeList",
    initialState: { value: [] },
    reducers: {
        updateTagTypeList: (state, action: PayloadAction<TClientTags[]>) => {
            state.value = action.payload;
        },
    },
});

const isAddTagTypeFormSubmittedSlice = createSlice({
    name: "isAddTagTypeFormSubmitted",
    initialState: { value: false },
    reducers: {
        setIsAddTagTypeFormSubmitted: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

export const { updateClientList } = clientListSlice.actions;
export const { updateActiveClientId } = activeClientIdSlice.actions;
export const { updateActiveClientGroupId } = activeClientGroupIdSlice.actions;
export const { updateClientTagsList } = clientTagsListSlice.actions;
export const { updateTagTypeList } = tagTypeListSlice.actions;
export const { setIsAddTagTypeFormSubmitted } =
    isAddTagTypeFormSubmittedSlice.actions;
export const { updateClientSubGroupId } = clientSubGroupIdSlice.actions;
export const { updateClientIdOnChannelChange } =
    clientIdOnChannelChangeSlice.actions;
export const { updateTagTypeListLoading } = tagTypeListLoadingSlice.actions;

export const clientListReducer = clientListSlice.reducer;
export const activeClientIdReducer = activeClientIdSlice.reducer;
export const activeClientGroupIdReducer = activeClientGroupIdSlice.reducer;
export const clientTagsListReducer = clientTagsListSlice.reducer;
export const tagTypeListReducer = tagTypeListSlice.reducer;
export const isAddTagTypeFormSubmittedReducer =
    isAddTagTypeFormSubmittedSlice.reducer;
export const clientSubGroupIdReducer = clientSubGroupIdSlice.reducer;
export const clientIdOnChannelChangeReducer =
    clientIdOnChannelChangeSlice.reducer;
export const tagTypeListLoadingReducer = tagTypeListLoadingSlice.reducer;